import React from 'react';
import { AppState } from 'app/store';
import { connect } from 'react-redux';
import {
  isAuthenticatedSelector,
  getAuthUser,
} from 'app/models/auth/selectors';
import { IncompleteProfileRoute } from 'app/constants/Routes';
import ConditionalRedirect, { RouteExcludes } from 'app/components/router/ConditionalRedirect';

interface IProps {
  isAuthenticated: boolean;
  profileCompleted: boolean;
  excludeRoutes: RouteExcludes;
  children: React.ReactNode;
}

export class IncompleteProfileRedirect extends React.Component<IProps> {
  public render() {
    const { isAuthenticated, profileCompleted, excludeRoutes } = this.props;
    return (
      <ConditionalRedirect
        to={IncompleteProfileRoute.getPathname()}
        when={isAuthenticated && !profileCompleted}
        excludeRoutes={excludeRoutes}
      >
        {this.props.children}
      </ConditionalRedirect>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  const isAuthenticated = isAuthenticatedSelector(state);
  const authUser = getAuthUser(state);

  return {
    isAuthenticated,
    profileCompleted: Boolean(authUser && authUser.profileCompleted),
  };
};

const IncompleteProfileRedirectInjectDependencies = connect(mapStateToProps)(IncompleteProfileRedirect);

export default IncompleteProfileRedirectInjectDependencies;
